import React from 'react'
import { colors } from '@mobi/component-library/Theme/Common'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'
import { trackBetLoopNotificationOpened } from '@core/Areas/FollowMe/helpers/analytics'
import type { IncomingBetLoopShare } from './types'

export const IncomingSharedBet: React.FC<{
  incomingShare: IncomingBetLoopShare
}> = ({ incomingShare }) => {
  const highlightRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!highlightRef.current) return

    trackBetLoopNotificationOpened(incomingShare.sharedBet.ticket.productName)

    const el = highlightRef.current
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    el.style.transition = 'outline 0.75s ease'
    el.style.outline = `2px solid ${colors.mariner[500]}`

    const timeMs = incomingShare.sharedBet.isResulted ? 6_000 : 2_500
    const timerId = window.setTimeout(() => {
      el.style.outline = '2px solid transparent'
    }, timeMs)

    return () => clearTimeout(timerId)
  }, [incomingShare.sharedBet])

  return (
    <SharedBetCard
      ref={highlightRef}
      sharedBet={incomingShare.sharedBet}
      shouldAutoOpenQuickbet={
        incomingShare.betOptionTab === 'pending-bets' && !incomingShare.isViewOnly
      }
    />
  )
}
